export default () => {
	const jsBurger = document.querySelector('.js-burger')
	const headerPanel = document.querySelector('.header__panel')

	jsBurger &&
		jsBurger.addEventListener('click', function () {
			this.classList.toggle('burger--active')
			headerPanel.classList.toggle('header__panel--active')
		})

	jsBurger &&
		document.querySelectorAll('.menu--mobile .menu__item').forEach((el) =>
			el.addEventListener('click', function () {
				jsBurger.classList.remove('burger--active')
				headerPanel.classList.remove('header__panel--active')
			})
		)

}
